<template>
  <div>
    <main v-visible="!pageReady">
      <b-spinner label="Loading"></b-spinner>
    </main>

    <main class="bots">
      <AdminRobotCard
        v-for="bot in bots"
        v-visible="pageReady"
        v-bind:key="bot.id"
        :available="bot.available"
        :description="bot.description"
        :id="bot.id"
        :imageSource="bot.image_source"
        :name="bot.name"
        :price="bot.credits_per_minute"
        :sessionInfo="bot.sessionInfo"
        :status="bot.status"
        :timezone="bot.timezone"
        :title="bot.title"
        :type="bot.type"
        v-on:session-ended="fetchSessions"
      />
    </main>
  </div>
</template>

<script>
import AdminRobotCard from "@/components/AdminRobotCard.vue";
import Rovers from "@/services/api/controllers/rovers";
import Sessions from "@/services/api/controllers/sessions";

import { access } from "fs";

export default {
  components: {
    AdminRobotCard
  },

  data: function() {
    return {
      bots: [],

      pageReady: true
    };
  },

  methods: {
    fetchSessions: async function() {
      try {
        this.pageReady = false;
        // Get the robots and sessions to display;
        const accessToken = await this.$auth.getTokenSilently();
        const sessions = await Sessions.index(accessToken);
        this.bots = await Rovers.index();

        // Map the session information to the appropriate bot if it exists
        for (const session of sessions) {
          for (const bot of this.bots) {
            if (session.rover_id === bot.id) {
              // If the session ID matches the bot id, break
              bot.sessionInfo = session;

              break;
            }
          }
        }
      } catch (error) {
        console.log("Failed to mount");
        console.log(error);
      } finally {
        this.pageReady = true;
      }
    }
  },

  async mounted() {
    await this.fetchSessions();
  }
};
</script>

<style scoped>
.bots {
  display: grid;
  height: 100px;
  grid-template-columns: repeat(2, 400px);
  column-gap: 40px;
  justify-content: center;
}
</style>
